import { Button } from '@repo/ui/components'
import { createFileRoute, Link } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/unauthorized')({
  component: UnauthorizedPage,
})

function UnauthorizedPage() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-16 text-center">
      <h1 className="text-4xl font-bold">401</h1>
      <h2 className="text-xl font-semibold">Unauthorized</h2>
      <p className="max-w-md text-muted-foreground">
        You don't have permission to access this page.
      </p>
      <Button asChild>
        <Link to="/login">Sign In</Link>
      </Button>
    </div>
  )
}
